import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/embeds`;

export const listEmbeds = (guildId) => apiRequest(base(guildId));
export const getEmbed = (guildId, type) => apiRequest(`${base(guildId)}/${encodeURIComponent(type)}`);
export const saveEmbed = (guildId, type, payload) =>
  apiRequest(`${base(guildId)}/${encodeURIComponent(type)}`, { method: "PATCH", body: payload });
export const deleteEmbed = (guildId, type) =>
  apiRequest(`${base(guildId)}/${encodeURIComponent(type)}`, { method: "DELETE" });

export const previewEmbed = (guildId, payload) =>
  apiRequest(`${base(guildId)}/preview`, { method: "POST", body: payload });
export const sendEmbed = (guildId, payload) =>
  apiRequest(`${base(guildId)}/send`, { method: "POST", body: payload });
export const sendStoredEmbed = (guildId, type, payload) =>
  apiRequest(`${base(guildId)}/${encodeURIComponent(type)}/send`, { method: "POST", body: payload });
